module.exports = __webpack_public_path__ + "static/media/Picture7.d260dfa4.jpg";